/**
 * Freeze V2 — Grid Navigation Hook
 *
 * Handles Tab/Enter key navigation across master-detail grids.
 * When pressing Tab on the last cell of a detail grid row, focus
 * moves to the next master row's detail grid.
 */
import { useCallback } from 'react';

import type { CellKeyDownEvent } from 'ag-grid-community';

export function useGridNav() {
  const handleCellKeyDown = useCallback((event: CellKeyDownEvent) => {
    const e = event.event as KeyboardEvent | undefined;
    if (!e) return;

    if (e.key === 'Enter') {
      // Move to next row, same column
      const currentRowIndex = event.node.rowIndex;
      if (currentRowIndex == null) return;

      const nextRow = event.api.getDisplayedRowAtIndex(currentRowIndex + 1);
      if (nextRow) {
        const col = event.column;
        event.api.setFocusedCell(currentRowIndex + 1, col);
        event.api.clearRangeSelection();
      }
    }
  }, []);

  return { handleCellKeyDown };
}
